import type { FaireProductEntity } from "../../entity_types/product";

export const p_aux6zsfr9t: FaireProductEntity = {
  token: "p_aux6zsfr9t",
  type: "product",
  name: "All Natural Kids Toothpaste - w/ Pump by Balm Baby",
  brandToken: "b_b3ffvix4",
  brandName: "Taylor's Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/50b20dd92195acd2b07679726475bcfc2995c6ec0084783430053588f8663482.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/846751942e0ef6608ad32c495b263f89caeae0c428343ec998a5368b0735e212.jpeg",
    "https://cdn.faire.com/fastly/1e493530ab8a81858bfd42a9c59184e5ab092afa738e0eb495b62c28757c4450.jpeg",
    "https://cdn.faire.com/fastly/7b4c973fc9156f8540fb1452f5473ad29fb986f5dd83d44f9fe5f0f188a4a8a6.jpeg",
    "https://cdn.faire.com/fastly/2f2ac66f3b48c23ec88c4532afca72bf988dd5ec993c372c11fc6a16dfd6c60c.jpeg",
    "https://cdn.faire.com/fastly/5e394b1a258430ac7f024d8e122f76f26093b2724cca11964404fb232564267d.jpeg",
    "https://cdn.faire.com/fastly/f357d23aa597786f4379a3f37c37ef94dc29301b9e286bb896b9785801c6f62e.jpeg",
    "https://cdn.faire.com/fastly/a036ae3b66c6ee373b75f74e7e0392bfa40442e3577f3708eb459a075e12f26b.jpeg",
  ],
  priceDollars: 6.5,
  description:
    'Kid approved. Tastes Great. Cleans and Protects\n\n* ALL Natural and Great for all ages!\n* Made in the USA\n* Vegan and Cruelty FREE (Leaping Bunny Certified)\n* Sugar FREE, sweetened with Xylitol\n* Glycerin FREE * Nut FREE * Gluten FREE * Fluoride FREE \n* Kids Love it! \n*  2.7 fl. oz. (4.2 oz NET WT)\nWe don\'t compromise when it comes to our ecosystem or your health!\n\nThis is our Kids "teeth" paste, and although our own kids call it "sugar paste" we can assure you this is Sugar FREE! It\'s just THAT sweet!\nSweetened with xylitol, it is great for little mouths, yet so sweet, your little ones will be asking to brush! Plus, studies show that xylitol is healthy for teeth! Yay! Everybody wins!\nCleans teeth and gums and keeps teeth protected and strong. Vegan and 100% NATURAL!\n\nIngredients:  Calcium Carbonate, non-GMO xylitol, non-GMO xanthan gum, distilled water, vitamin e, essential oils (that\'s it - sweet and simple)',
  tags: [],
  msrpDollars: 11.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:26.333Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
